module.exports = __webpack_public_path__ + "static/media/fraction-subtraction.d7f5cfce.svg";